const DEFAULT_COUNTRY_CODE = "84"
/** Vietnam's national significant number (NSN) has 9 digits; used to detect input that already has the country code. */
const MIN_NATIONAL_NUMBER_LENGTH = 9

/**
 * Normalize a phone number to E.164 (digits only, without "+"). Idempotent:
 * "0901234567", "901234567", "84901234567", "+84 901 234 567" -> "84901234567".
 * - "+...": already has the real country code -> keep it (do not default to "84").
 * - "0...": drop the leading 0 (trunk prefix), then prepend the country code.
 * - Starts with the country code and the rest is long enough -> already E.164.
 *   E.g. "843123456" (9 digits, 084 prefix) is still a domestic number -> "84843123456".
 */
export const normalizePhoneE164 = (phone?: string | null, countryCode?: string | null) => {
  const raw = String(phone ?? "").trim()
  const digits = raw.replace(/\D/g, "")
  if (!digits) return ""

  if (raw.startsWith("+")) return digits

  const code = String(countryCode ?? "").replace(/\D/g, "") || DEFAULT_COUNTRY_CODE
  if (digits.startsWith("0")) return `${code}${digits.slice(1)}`
  if (digits.startsWith(code) && digits.length - code.length >= MIN_NATIONAL_NUMBER_LENGTH) return digits
  return `${code}${digits}`
}

export const formatPhoneNumber = (phone?: string) => {
  if (!phone || phone.length < 9) {
    return ""
  }
  return normalizePhoneE164(phone)
}
